// extracted by mini-css-extract-plugin
export default {"r_l":"b6307be7b6 _91e7950737","t":"_52d1f5994a"};